import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { DesignerPage } from "./pages/DesignerPage";
import { GuidePage } from "./pages/GuidePage";
import { BlogPage } from "./pages/BlogPage";
import { BlogPostPage } from "./pages/BlogPostPage";
import { ComparePage } from "./pages/ComparePage";
import { ComparisonDetailPage } from "./pages/ComparisonDetailPage";
import { PartnersPage } from "./pages/PartnersPage";
import { PartnerDetailPage } from "./pages/PartnerDetailPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { AffiliateDisclosurePage } from "./pages/AffiliateDisclosurePage";
import { AdminDashboard } from "./pages/AdminDashboard";
import { ClusterPage } from "./pages/ClusterPage";
import { AuthorPage } from "./pages/AuthorPage";
import { InvestmentsPage } from "./pages/InvestmentsPage";
import { InvestmentDetailPage } from "./pages/InvestmentDetailPage";
import { DropsPage } from "./pages/DropsPage";
import { CelebrityPage } from "./pages/CelebrityPage";
import { ComparisonPage } from "./pages/ComparisonPage";
import { ComparisonsIndexPage } from "./pages/ComparisonsIndexPage";
import { MethodologyPage } from "./pages/MethodologyPage";
import { ToolsIndexPage } from "./pages/ToolsIndexPage";
import { AuthenticationQuizPage } from "./pages/AuthenticationQuizPage";
import { ROICalculatorPage } from "./pages/ROICalculatorPage";
import { GlossaryPage } from "./pages/GlossaryPage";
import { GlossaryTermPage } from "./pages/GlossaryTermPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin Routes (no layout) */}
        <Route path="/admin" element={<AdminDashboard />} />
        
        {/* Public Routes with Layout */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        
        {/* Designer Routes */}
        <Route path="/designers/:slug" element={<Layout><DesignerPage /></Layout>} />
        
        {/* Guide Routes */}
        <Route path="/guides/:slug" element={<Layout><GuidePage /></Layout>} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
        <Route path="/blog/:slug" element={<Layout><BlogPostPage /></Layout>} />

        {/* Topic Cluster Hub */}
        <Route path="/clusters/:slug" element={<Layout><ClusterPage /></Layout>} />

        {/* Author Bio Pages */}
        <Route path="/authors/:slug" element={<Layout><AuthorPage /></Layout>} />

        {/* Moat Trio — Investment Index, Drop Tracker, Celebrity */}
        <Route path="/investments" element={<Layout><InvestmentsPage /></Layout>} />
        <Route path="/investments/:slug" element={<Layout><InvestmentDetailPage /></Layout>} />
        <Route path="/drops" element={<Layout><DropsPage /></Layout>} />
        <Route path="/celebrity-jewelry" element={<Layout><CelebrityPage /></Layout>} />
        <Route path="/methodology" element={<Layout><MethodologyPage /></Layout>} />
        <Route path="/glossary" element={<Layout><GlossaryPage /></Layout>} />
        <Route path="/glossary/:slug" element={<Layout><GlossaryTermPage /></Layout>} />
        
        <Route path="/tools" element={<Layout><ToolsIndexPage /></Layout>} />
        <Route path="/tools/authenticate/:slug" element={<Layout><AuthenticationQuizPage /></Layout>} />
        <Route path="/tools/roi-calculator" element={<Layout><ROICalculatorPage /></Layout>} />
        {/* Compare Routes */}
        <Route path="/compare" element={<Layout><ComparePage /></Layout>} />
        <Route path="/compare/:slug" element={<Layout><ComparisonDetailPage /></Layout>} />
        <Route path="/vs" element={<Layout><ComparisonsIndexPage /></Layout>} />
        <Route path="/vs/:slug" element={<Layout><ComparisonPage /></Layout>} />
        
        {/* Partner Routes */}
        <Route path="/partners" element={<Layout><PartnersPage /></Layout>} />
        <Route path="/partners/:slug" element={<Layout><PartnerDetailPage /></Layout>} />
        
        {/* Static Pages */}
        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/affiliate-disclosure" element={<Layout><AffiliateDisclosurePage /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
